import { render, staticRenderFns } from "./Flexy.vue?vue&type=template&id=7cfb77d8&"
import script from "./Flexy.vue?vue&type=script&lang=js&"
export * from "./Flexy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports